import { render, staticRenderFns } from "./ResourcesContainer.vue?vue&type=template&id=6b8df8b4&scoped=true&"
import script from "./ResourcesContainer.vue?vue&type=script&lang=js&"
export * from "./ResourcesContainer.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesContainer.vue?vue&type=style&index=0&id=6b8df8b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8df8b4",
  null
  
)

export default component.exports